import React from "react";
import {  
    Box, 
    VStack,
    Heading, 
    Link,
} from '@chakra-ui/react';
import { useTheme } from '@chakra-ui/react';

const EmailLinks = () => {
    const theme = useTheme();

    const EmailButtonClicked = () => {
        const emailSubject = 'Inquiry about ';
        const emailBody = `
        Hi Ayaan,

        `;
      
        const mailtoUrl = `mailto:ayaanishere08@gmail.com?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
        window.open(mailtoUrl, "_blank");
      }

    return(
        <VStack position={'fixed'} 
        h={'100%'} 
        top={'50%'}
         >   
            <Link onClick={EmailButtonClicked}>
                <Heading
                    writingMode="vertical-rl"
                    textOrientation="mixed"
                    transform="rotate(-270deg)"
                    fontSize={{ base: "20px", md: "24px", lg: "24px" }}
                    weight={400}
                    px='1em'
                    marginBottom={'6em'}
                    fontFamily={theme.font.primary}
                    color={theme.colors.primary}
                    >
                    ayaanishere08@gmail.com
                </Heading>
            </Link>        
            <Box 
                h="100%" variant='solid' 
                bottom={'0'}
                orientation='vertical'  
                borderWidth= '2px' 
                borderStyle= "solid"
                borderRadius= '10'
                borderColor={theme.colors.primary} >
            </Box>
        </VStack>
    )
}

export default EmailLinks